import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import { Spinner } from '@uva-glass/component-library';

import styles from './MainLayoutPage.module.css';

import { useDynamicImport } from 'hooks/useDynamicImport';
import { REMOTE_MODULES } from 'routes/remoteModules';

interface RemoteModuleLoaderProps {
  remote: keyof typeof REMOTE_MODULES;
}

export const RemoteModuleLoader = ({ remote }: RemoteModuleLoaderProps) => {
  const { t } = useTranslation('common', { keyPrefix: 'common' });
  const { getRemote, loading, Remote } = useDynamicImport();

  useEffect(() => {
    getRemote(REMOTE_MODULES[remote].module, REMOTE_MODULES[remote].scope, t('loading-error'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [remote]);

  return (
    <>
      {loading ? (
        <div className={styles['spinner-container']}>
          <Spinner ariaValueText={t('loading')} />
        </div>
      ) : (
        <Remote />
      )}
    </>
  );
};
